import React, { useState, useEffect } from "react";

import PaymentService from "../../../services/payment/PaymentService";

import Header from "../header/Header";
import {
  Postback,
  PostbackStatus
} from "@cdkglobal/onepay-component/cjs/components/_onePay/middle/postback/Postback";

import "./PostbackWrapper.css";

const STATUS = {
  paid: "PAID",
  unpaid: "UNPAID",
  failed: "FAILED"
};

const PostbackWrapper = props => {
  const [postbackStatus, setPostbackStatus] = useState({
    ...PostbackStatus.initialStatus()
  });
  const [postbackInitiated, setPostbackInitiated] = useState(false);
  const [error, setError] = useState(undefined);
  const [warning, setWarning] = useState(undefined);
  const [success, setSuccess] = useState(undefined);

  const retryPostback = async () => {
    const { steps } = { ...postbackStatus };

    for (let step of steps) {
      step.isCompleted = false;
      step.isError = false;
    }

    setPostbackStatus({
      steps,
      activeStep: 0
    });

    setError(undefined);
    setSuccess(undefined);
    setWarning(undefined);
    setTimeout(initiatePostback, 500);
  };

  const initiatePostback = async () => {
    const validateStatusResponse = await PaymentService.validatePaymentStatus();

    if (validateStatusResponse.isError) {
      await setStepError(0, validateStatusResponse.message);
      return;
    }

    setStepSuccess(0);

    const postbackResponse = await PaymentService.postback();

    if (postbackResponse.isError) {
      await setStepError(1, postbackResponse.message);
      return;
    }

    setStepSuccess(1);

    if (postbackResponse.isWarning) {
      await setStepWarning(2, postbackResponse.message);
      return;
    }

    setTimeout(completeWithSuccess(postbackResponse), 500);
  };

  const validateStatusParam = () => {
    const url = props.location.search;
    const status = new URLSearchParams(url).get("status");

    if (STATUS.unpaid === status || STATUS.failed === status) {
      window.close();
      return false;
    }

    return true;
  };

  const setStepSuccess = step => {
    const { steps } = { ...postbackStatus };

    for (let i = 0; i <= step; i++) {
      steps[i].isCompleted = true;
    }

    setPostbackStatus({
      steps,
      activeStep: step + 1
    });
  };

  const setStepError = async (step, errorMessage) => {
    const { steps } = { ...postbackStatus };

    steps[step].isCompleted = false;
    steps[step].isError = true;

    setPostbackStatus({
      steps,
      activeStep: step
    });

    setError({
      message: errorMessage,
      retry: () => {
        retryPostback();
      }
    });
  };

  const setStepWarning = async (step, warningMessage) => {
    const { steps } = { ...postbackStatus };

    steps[step].isCompleted = false;
    steps[step].isWarning = true;

    setPostbackStatus({
      steps,
      activeStep: step
    });

    setWarning({
      message: warningMessage,
      close: true,
      onClose: () => {
        window.close();
      }
    });
  };

  const completeWithSuccess = postbackResponse => {
    const { pageId } = postbackResponse.postbackInfo.kvDetails;
    setStepSuccess(2);

    setTimeout(function() {
      window.close();
    }, 0);

    if (pageId.split("_")[1] === "SNXT") {
      setTimeout(function() {
        if (postbackResponse.postbackInfo.kvDetails.callBackUrl) {
          window.parent.location =
            postbackResponse.postbackInfo.kvDetails.callBackUrl;
        }
      }, 5000);
    }

    setSuccess({
      message: `Payment processed with success! The window will close automatically in 5 seconds.`,
      close: true,
      onClose: () => {
        window.close();
        if (pageId.split("_")[1] === "SNXT") {
          if (postbackResponse.postbackInfo.kvDetails.callBackUrl) {
            window.parent.location =
              postbackResponse.postbackInfo.kvDetails.callBackUrl;
          }
        }
      }
    });
  };

  useEffect(() => {
    if (!postbackInitiated) {
      setPostbackInitiated(true);
      if (validateStatusParam()) {
        initiatePostback();
      }
    }
  });

  return (
    <div>
      <Header />
      <div className={"onepay-postback-container"}>
        <Postback
          status={postbackStatus}
          error={error}
          success={success}
          warning={warning}
        />
      </div>
    </div>
  );
};

export default PostbackWrapper;
